// Redux
import { Dispatch } from "redux";

// Classes
import {
  DateRegistered,
  RelativeEngagement,
  TotalTimeSpent,
  Activity,
  EngagementReducerState
} from "../classes/engagement.classes";
import { Range } from "../../classes/filter.classes";

// Action Creators
import {
  setDateRegistered,
  setRelativeEngagement,
  setTotalTimeSpent,
  setScheduledVisit,
  setApplied,
  setActivityWithInstitution,
  setActivityWithEAB,
  setEngagementState
} from "../actionCreators/engagement.actionCreators";

import { EngagementDefaultDates } from "Components/RangeDatePicker";
const { defaultStartDate, defaultEndDate } = EngagementDefaultDates;
export const setDateRegisteredValue = (
  dispatch: Dispatch<any>,
  dateRegistered: DateRegistered,
  value: any,
  identifier: any
) => {
  // Use onChange event given from the component to construct a DateRegistered and pass it to Redux.
  let newDateRegistered: DateRegistered;
  if (identifier === "dateRegistered") {
    newDateRegistered = {
      ...dateRegistered,
      selection: value
    };
    newDateRegistered.selection = value;
    switch (value) {
      case "Select Recency":
        // Intitialize the Date Range for whatever the initial value of the dropdown
        // should be (I do not currently know it)
        newDateRegistered.value = {
          label: "Within Last 30 Days",
          value: "Within_Last_30_Days"
        };
        break;
      //Use this for the default?
      case "Specific Date Range":
        // Intitialize the Specific Date Range with the defaults from EngagementDefaultDates
        newDateRegistered.value = new Range(defaultStartDate, defaultEndDate);
        break;
      default:
        //Remove the value, it contains the dates or the Recency value
        newDateRegistered.value = undefined;
        delete newDateRegistered.value;
        break;
    }
  } else {
    newDateRegistered = {
      ...dateRegistered,
      selection: identifier
    };

    switch (identifier) {
      case "Specific Date Range":
        newDateRegistered.value = new Range(value.lower, value.upper);
        break;
      case "Select Recency":
        newDateRegistered.value = value;
        break;
      default:
        newDateRegistered.value = value;
        break;
    }
  }

  dispatch(setDateRegistered(newDateRegistered));
};

export const setRelativeEngagementValue = (
  dispatch: Dispatch<any>,
  relativeEngagement: RelativeEngagement,
  identifier: "high" | "medium" | "low"
) => {
  // Use identifier given from the component to construct a
  // RelativeEngagement and pass it to Redux.
  const newRelativeEngagement = {
    ...relativeEngagement,
    [identifier]: !relativeEngagement[identifier]
  };

  dispatch(setRelativeEngagement(newRelativeEngagement));
};
export const clearRelativeEngagement = (dispatch: Dispatch<any>) => {
  //Pass in an empty class to reset
  dispatch(setRelativeEngagement(new RelativeEngagement()));
};

export const selectAllRelativeEngagement = (dispatch: Dispatch<any>) => {
  //Pass in an empty class to reset
  dispatch(setRelativeEngagement(new RelativeEngagement(true, true, true)));
};

export const setTotalTimeSpentValue = (
  dispatch: Dispatch<any>,
  totalTimeSpent: TotalTimeSpent,
  value: any,
  identifier: "selection" | "vt" | "iwc"
) => {
  // Use onChange event given from the component to construct a
  // TotalTimeSpent and pass it to Redux.
  let newTotalTimeSpent: TotalTimeSpent;

  if (identifier === "selection") {
    newTotalTimeSpent = {
      ...totalTimeSpent,
      selection: value
    };
    switch (value) {
      case "VT":
        // Intitialize the time spent here for the opposite,
        // but do not use it when we apply the filter since only
        // "VT" is checked.  (Note:  I dont know the actual range)
        newTotalTimeSpent.value.iwc = new Range(1, 15);
        break;
      case "IWC":
        // Intitialize the time spent here for the opposite,
        // but do not use it when we apply the filter since only
        // "IWC" is checked.  (Note:  I dont know the actual range)
        newTotalTimeSpent.value.vt = new Range(1, 15);
        break;
    }
  } else {
    newTotalTimeSpent = {
      ...totalTimeSpent,
      value: {
        ...totalTimeSpent.value,
        [identifier]: value
      }
    };
  }

  dispatch(setTotalTimeSpent(newTotalTimeSpent));
};

export const setScheduledVisitValue = (
  dispatch: Dispatch<any>,
  value: "Any" | "Yes" | "No"
) => {
  dispatch(setScheduledVisit(value));
};

export const setAppliedValue = (
  dispatch: Dispatch<any>,
  value: "Any" | "Yes" | "No"
) => {
  dispatch(setApplied(value));
};

export const setActivityWithInstitutionValue = (
  dispatch: Dispatch<any>,
  activityWithInstitution: Activity,
  value: any,
  identifier: any
) => {
  // Use onChange event given from the component to construct a
  // Activity and pass it to Redux.
  let newActivityWithInstitution: Activity;

  if (identifier === "activityWithInstitution") {
    newActivityWithInstitution = {
      ...activityWithInstitution,
      selection: value
    };
    switch (value) {
      case "Active":
      case "Inactive": //Default for the drop down
        newActivityWithInstitution.value = {
          label: "Within Last 30 Days",
          value: "Within_Last_30_Days"
        };
        break;
      default:
        newActivityWithInstitution.value = value;
        break;
    }
  } else {
    newActivityWithInstitution = {
      ...activityWithInstitution,
      value: value,
      selection: identifier
    };
  }

  dispatch(setActivityWithInstitution(newActivityWithInstitution));
};

export const setActivityWithEABValue = (
  dispatch: Dispatch<any>,
  activityWithEAB: Activity,
  value: any,
  identifier: any
) => {
  // Use onChange event given from the component to construct a
  // Activity and pass it to Redux.
  let newActivityWithEAB: Activity;

  if (identifier === "activityWithEAB") {
    newActivityWithEAB = {
      ...activityWithEAB,
      selection: value
    };

    switch (value) {
      case "Active":
      case "Inactive": //Default for the drop down
        newActivityWithEAB.value = {
          label: "Within Last 30 Days",
          value: "Within_Last_30_Days"
        };
        break;
      default:
        newActivityWithEAB.value = value;
        break;
    }
  } else {
    newActivityWithEAB = {
      ...activityWithEAB,
      value: value,
      selection: identifier
    };
  }

  dispatch(setActivityWithEAB(newActivityWithEAB));
};

export const initializeEngagementState = (
  dispatch: Dispatch<any>,
  state: EngagementReducerState
) => {
  dispatch(setEngagementState(state));
};
try {
    // @ts-ignore
    clearRelativeEngagement.displayName = "clearRelativeEngagement";
    // @ts-ignore
    clearRelativeEngagement.__docgenInfo = { "description": "", "displayName": "clearRelativeEngagement", "props": { "apply": { "defaultValue": null, "description": "Calls the function, substituting the specified object for the this value of the function, and the specified array for the arguments of the function.\n@param thisArg The object to be used as the this object.\n@param argArray A set of arguments to be passed to the function.", "name": "apply", "required": true, "type": { "name": "(this: Function, thisArg: any, argArray?: any) => any" } }, "call": { "defaultValue": null, "description": "Calls a method of an object, substituting another object for the current object.\n@param thisArg The object to be used as the current object.\n@param argArray A list of arguments to be passed to the method.", "name": "call", "required": true, "type": { "name": "(this: Function, thisArg: any, ...argArray: any[]) => any" } }, "bind": { "defaultValue": null, "description": "For a given function, creates a bound function that has the same body as the original function.\nThe this object of the bound function is associated with the specified object, and has the specified initial parameters.\n@param thisArg An object to which the this keyword can refer inside the new function.\n@param argArray A list of arguments to be passed to the new function.", "name": "bind", "required": true, "type": { "name": "(this: Function, thisArg: any, ...argArray: any[]) => any" } }, "toString": { "defaultValue": null, "description": "Returns a string representation of a function.", "name": "toString", "required": false, "type": { "name": "() => string" } }, "prototype": { "defaultValue": null, "description": "", "name": "prototype", "required": true, "type": { "name": "any" } }, "length": { "defaultValue": null, "description": "", "name": "length", "required": true, "type": { "name": "number" } }, "arguments": { "defaultValue": null, "description": "", "name": "arguments", "required": true, "type": { "name": "any" } }, "caller": { "defaultValue": null, "description": "", "name": "caller", "required": true, "type": { "name": "Function" } }, "name": { "defaultValue": null, "description": "Returns the name of the function. Function names are read-only and can not be changed.", "name": "name", "required": true, "type": { "name": "string" } }, "__@hasInstance": { "defaultValue": null, "description": "Determines whether the given value inherits from this function if this function was used\nas a constructor function.\n\nA constructor function can control which objects are recognized as its instances by\n'instanceof' by overriding this method.", "name": "__@hasInstance", "required": true, "type": { "name": "(value: any) => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Engagement/actions/engagement.actions.ts#clearRelativeEngagement"] = { docgenInfo: clearRelativeEngagement.__docgenInfo, name: "clearRelativeEngagement", path: "src/shared/containers/Filter/Engagement/actions/engagement.actions.ts#clearRelativeEngagement" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    selectAllRelativeEngagement.displayName = "selectAllRelativeEngagement";
    // @ts-ignore
    selectAllRelativeEngagement.__docgenInfo = { "description": "", "displayName": "selectAllRelativeEngagement", "props": { "apply": { "defaultValue": null, "description": "Calls the function, substituting the specified object for the this value of the function, and the specified array for the arguments of the function.\n@param thisArg The object to be used as the this object.\n@param argArray A set of arguments to be passed to the function.", "name": "apply", "required": true, "type": { "name": "(this: Function, thisArg: any, argArray?: any) => any" } }, "call": { "defaultValue": null, "description": "Calls a method of an object, substituting another object for the current object.\n@param thisArg The object to be used as the current object.\n@param argArray A list of arguments to be passed to the method.", "name": "call", "required": true, "type": { "name": "(this: Function, thisArg: any, ...argArray: any[]) => any" } }, "bind": { "defaultValue": null, "description": "For a given function, creates a bound function that has the same body as the original function.\nThe this object of the bound function is associated with the specified object, and has the specified initial parameters.\n@param thisArg An object to which the this keyword can refer inside the new function.\n@param argArray A list of arguments to be passed to the new function.", "name": "bind", "required": true, "type": { "name": "(this: Function, thisArg: any, ...argArray: any[]) => any" } }, "toString": { "defaultValue": null, "description": "Returns a string representation of a function.", "name": "toString", "required": false, "type": { "name": "() => string" } }, "prototype": { "defaultValue": null, "description": "", "name": "prototype", "required": true, "type": { "name": "any" } }, "length": { "defaultValue": null, "description": "", "name": "length", "required": true, "type": { "name": "number" } }, "arguments": { "defaultValue": null, "description": "", "name": "arguments", "required": true, "type": { "name": "any" } }, "caller": { "defaultValue": null, "description": "", "name": "caller", "required": true, "type": { "name": "Function" } }, "name": { "defaultValue": null, "description": "Returns the name of the function. Function names are read-only and can not be changed.", "name": "name", "required": true, "type": { "name": "string" } }, "__@hasInstance": { "defaultValue": null, "description": "Determines whether the given value inherits from this function if this function was used\nas a constructor function.\n\nA constructor function can control which objects are recognized as its instances by\n'instanceof' by overriding this method.", "name": "__@hasInstance", "required": true, "type": { "name": "(value: any) => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Engagement/actions/engagement.actions.ts#selectAllRelativeEngagement"] = { docgenInfo: selectAllRelativeEngagement.__docgenInfo, name: "selectAllRelativeEngagement", path: "src/shared/containers/Filter/Engagement/actions/engagement.actions.ts#selectAllRelativeEngagement" };
}
catch (__react_docgen_typescript_loader_error) { }